module.exports = __webpack_public_path__ + "img/je.93b8563.svg";